module.exports = __webpack_public_path__ + "img/W-C30.8af52f0f.jpg";